import { QuestionTypeName } from '../../learnware/LearnwareEnums';
export class CycleInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get cycle() {
        return this.parent;
    }
    get app() {
        return this.parent.app;
    }
    get isShowingLastQuestion() {
        return this.cycle.frontalNumber >= this.cycle.cycleAnswers.allAnswersInCycle.length;
    }
    get isShowingReward() {
        return this.app.question && this.app.question.questionType === QuestionTypeName.CycleEnd;
    }
    get cycleIndexSincePageLoad() {
        return (this.cycle.cycleIndex -
            Math.floor(this.app.history.historyAnswers.answersFromDatabase.length / this.app.tray.trayCycles.pensumPerCycle));
    }
}
